'use strict';

var get = require('dlv');

var mergeOptions = require('merge-options');

var errCode = require('err-code');

var PubsubRouters = require('../runtime/libp2p-pubsub-routers-nodejs');

module.exports = function (_ref) {
  var options = _ref.options,
      peerInfo = _ref.peerInfo,
      repo = _ref.repo,
      config = _ref.config;
  options = options || {};
  config = config || {};
  var datastore = repo.datastore;
  var libp2pOptions = getLibp2pOptions({
    options: options,
    config: config,
    datastore: datastore,
    peerInfo: peerInfo
  });

  if (typeof options.libp2p === 'function') {
    return options.libp2p({
      libp2pOptions: libp2pOptions,
      options: options,
      config: config,
      datastore: datastore,
      peerInfo: peerInfo
    });
  } // Required inline to reduce startup time


  var Libp2p = require('libp2p');

  return new Libp2p(mergeOptions(libp2pOptions, get(options, 'libp2p', {})));
};

function getLibp2pOptions(_ref2) {
  var options = _ref2.options,
      config = _ref2.config,
      datastore = _ref2.datastore,
      peerInfo = _ref2.peerInfo;

  var getPubsubRouter = function getPubsubRouter() {
    var router = get(config, 'Pubsub.Router') || 'gossipsub';

    if (!PubsubRouters[router]) {
      throw errCode(new Error("Router unavailable. Configure libp2p.modules.pubsub to use the ".concat(router, " router.")), 'ERR_NOT_SUPPORTED');
    }

    return PubsubRouters[router];
  };

  var libp2pDefaults = {
    datastore: datastore,
    peerInfo: peerInfo,
    modules: {}
  };
  var bootstrapList = get(options, 'config.Bootstrap', get(config, 'Bootstrap', []));
  var libp2pOptions = {
    modules: {
      pubsub: getPubsubRouter()
    },
    config: {
      peerDiscovery: {
        mdns: {
          enabled: get(options, 'config.Discovery.MDNS.Enabled', get(config, 'Discovery.MDNS.Enabled', true))
        },
        webRTCStar: {
          enabled: get(options, 'config.Discovery.webRTCStar.Enabled', get(config, 'Discovery.webRTCStar.Enabled', true))
        },
        bootstrap: {
          list: bootstrapList
        }
      },
      relay: {
        enabled: get(options, 'relay.enabled', get(config, 'relay.enabled', true)),
        hop: {
          enabled: get(options, 'relay.hop.enabled', get(config, 'relay.hop.enabled', false)),
          active: get(options, 'relay.hop.active', get(config, 'relay.hop.active', false))
        }
      },
      dht: {
        kBucketSize: get(options, 'dht.kBucketSize', 20)
      },
      pubsub: {
        enabled: get(options, 'config.Pubsub.Enabled', get(config, 'Pubsub.Enabled', true))
      }
    },
    connectionManager: get(options, 'connectionManager', {
      maxConnections: get(options, 'config.Swarm.ConnMgr.HighWater', get(config, 'Swarm.ConnMgr.HighWater')),
      minConnections: get(options, 'config.Swarm.ConnMgr.LowWater', get(config, 'Swarm.ConnMgr.LowWater'))
    })
  }; // Required inline to reduce startup time
  // Note: libp2p-nodejs gets replaced by libp2p-browser when webpacked/browserified

  var getEnvLibp2pOptions = require('../runtime/libp2p-nodejs'); // Merge defaults with Node.js/browser/other environments options and configuration


  var libp2pConfig = mergeOptions(libp2pDefaults, getEnvLibp2pOptions(), libp2pOptions);

  if (bootstrapList.length > 0) {
    libp2pConfig.modules.peerDiscovery.push(require('libp2p-bootstrap'));
  }

  return libp2pConfig;
}